import React from 'react';

import range from 'lodash/range';
import {Link} from 'react-router';

import type {StoredResponseType} from 'app/utils/redux_v2';
import type {Location} from 'history';

const DEFAULT_PAGE_NUM = '1';

export interface Props<T> {
  page?: string | number;
  className?: string;
  pageParamName?: string;
  response: StoredResponseType<T>;
}

export function LinkPagination<T>({
  page = DEFAULT_PAGE_NUM,
  response,
  className,
  pageParamName = 'page',
}: Props<T>): JSX.Element | null {
  if (response.loading === true || response.numPages < 2) {
    return null;
  }

  const {numPages, next, previous} = response;

  const links = range(1, numPages + 1).map((pageIndex) => ({
    active: pageIndex.toString() === page,
    page: pageIndex.toString(),
  }));

  return (
    <div
      className={`d-flex justify-content-center ${
        className != null ? className : ''
      }`}
    >
      <ul className="pagination mx-auto flex-wrap justify-content-center">
        {previous != null ? (
          <li key={'previous'} className="page-item">
            <Link
              className="page-link"
              to={createPaginationClickHandler(previous, pageParamName)}
            >
              <i className="fa fa-arrow-left" />
            </Link>
          </li>
        ) : null}
        {links.map((link) => (
          <li
            key={link.page}
            className={`page-item ${link.active ? 'active' : ''}`}
          >
            <Link
              className="page-link"
              to={createPaginationClickHandler(link.page, pageParamName)}
            >
              {link.page}
            </Link>
          </li>
        ))}
        {next != null ? (
          <li key={'next'} className="page-item">
            <Link
              className="page-link"
              to={createPaginationClickHandler(next, pageParamName)}
            >
              <i className="fa fa-arrow-right" />
            </Link>
          </li>
        ) : null}
      </ul>
    </div>
  );
}

const createPaginationClickHandler =
  (pageIndex: number | string, pageParamName: string) =>
  (location: Location) => ({
    pathname: location.pathname,
    query: {
      ...location.query,
      [pageParamName]: pageIndex,
    },
  });
